import { Phone } from "lucide-react";

import { useSupportPhoneNumber } from "@design-lab/shared/lib/config";

export function ContactUs() {
  const supportPhoneNumber = useSupportPhoneNumber();
  return (
    <div className="flex items-center justify-center gap-3 py-1">
      <div className="flex size-10 flex-shrink-0 items-center justify-center rounded-full bg-[#2663EB] p-2">
        <Phone className="size-6 text-white" />
      </div>

      <div className="flex flex-col gap-1">
        <a
          className="font-inter text-lg font-bold leading-[1.2] !text-[#165DFC] hover:underline"
          href={`tel:${supportPhoneNumber.replace(/[^\d+]/g, "")}`}
          data-testid="contact-us-link"
        >
          {supportPhoneNumber}
        </a>
      </div>
    </div>
  );
}
